// All JavaScript in here will be loaded server-side
// Expose components globally so ReactJS.Net can use them


require('expose-loader?exposes=components!./components');